import { useState, useRef } from "react";
import {
  Edit,
  FormDataConsumer,
  SimpleForm,
  TextInput,
  ImageInput,
  ImageField,
  SelectInput,
  BooleanInput,
  required,
} from "react-admin";
import { Typography } from "@mui/material";
import { editTitle, customImageStyle } from "customStyles/ra-custom-styles";
import { newsChoices, languageChoices } from "utils/options";
import CustomImage from "../Partials/CustomComponents/CustomImage";
import { ActiveEditToolbar } from "components/features/Partials/CustomComponents/ActiveSaveToolbar";
import CustomDateInput from "common/components/Fields/CustomDateInput";
import { JoditEditorCustom } from "../Partials/CustomComponents/JoditEditorCustom";

const EditNews = () => {
  const [newContent, setContent] = useState(null);

  const transform = data => ({
    ...data,
    content: newContent !== null ? newContent : data.content,
  });

  const setContentValue = newContent => setContent(newContent);

  return (
    <Edit
      title="Новина към каталог"
      mutationMode="pessimistic"
      transform={transform}
    >
      <Typography sx={editTitle}>Редакция на новина към каталог</Typography>
      <SimpleForm toolbar={<ActiveEditToolbar />}>
        <SelectInput
          label="Език"
          source="language"
          choices={languageChoices}
          validate={required()}
        />
        <TextInput
          label="Заглавие"
          source="title"
          validate={required()}
          multiline
          fullWidth
        />
        <SelectInput
          label="Тип"
          source="news_type"
          validate={required()}
          choices={newsChoices}
          fullWidth
        />
        <TextInput
          label="Подзаглавие"
          source="sub_head"
          multiline
          fullWidth
        />
        <CustomDateInput
          label="Начална дата"
          source="starting_on"
          validate={required()}
        />
        <CustomDateInput
          label="До дата"
          source="ending_on"
        />
        <CustomDateInput
          label="Дата на публикуване"
          source="date_beginning"
          validate={required()}
        />
        <TextInput
          label="Кратко описание"
          source="short_description"
          fullWidth
          multiline
        />
        <TextInput
          label="Ключови думи"
          source="tags"
          multiline
          fullWidth
        />
        <FormDataConsumer>
          {({ formData }) => {
            return (
              <JoditEditorCustom
                value={formData?.content}
                onBlur={setContentValue}
              />
            );
          }}
        </FormDataConsumer>
        <CustomImage
          label={"Текуща снимка"}
          style={customImageStyle}
        />
        <ImageInput
          placeholder="Добавете снимка"
          label="Снимка"
          source="file"
          accept="image/*"
        >
          <ImageField
            source="src"
            title="title"
          />
        </ImageInput>
        <BooleanInput
          label="Скрита"
          source="is_hidden"
        />
      </SimpleForm>
    </Edit>
  );
};

export default EditNews;
